/**
 * Solo's trace decision (ADR 0035): solo has no room to decide, so it asks the api for the game's
 * share once per page (`/api/trace-plan`) and rolls for each play. A failed request means not
 * traced: tracing never gets in the way of playing.
 */
type Plan = { rate: number; why: "sample" | "switch" };
const plans = new Map<string, Promise<Plan | null>>();

export async function soloTrace(
  game: string,
  version: string,
  roll: () => number = Math.random,
): Promise<"sample" | "switch" | null> {
  const key = `${game}@${version}`;
  let plan = plans.get(key);
  if (!plan) {
    plan = fetch(
      `/api/trace-plan?game=${encodeURIComponent(game)}&version=${encodeURIComponent(version)}`,
    )
      .then((res) => (res.ok ? (res.json() as Promise<Plan>) : null))
      .catch(() => null);
    plans.set(key, plan);
  }
  const p = await plan;
  return p && roll() < p.rate ? p.why : null;
}
